import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-plus-white',
  templateUrl: './icon-plus-white.component.html',
  styles: []
})
export class IconPlusWhiteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
